import { html } from "lit-html";
import { Base } from "@escapio/shared/components/dialogs/Base";
import { LIST_CONTEXT_CRITERIA_POPUP } from "@escapio/shared/components/picture-sizes";
import "@escapio/shared/components/Picture";

export class ContextCriteriaPicturePopup extends Base {
	constructor() {
		super();
		this.node.classList.add(
			"dialog--popup-desktop",
			"dialog--popup-with-picture",
		);
		this.image = null;
	}

	getTemplateHeaderRight() {
		return html`<button
			class="dialog__header-close close-icon close-icon--with-hover close-icon--large"
			@click=${this.hide}
		></button>`;
	}

	getTemplateContent() {
		return html`
			<esc-picture
				filename=${this.image.filename}
				sizes-key="${LIST_CONTEXT_CRITERIA_POPUP}"
			></esc-picture>
		`;
	}

	show(image) {
		this.image = image;
		super.show();
	}
}
